import { format } from 'date-fns';

import MarShopping from '../../../../assets/img/mar-shopping-blackwhite.png';

export default function CustomerCouponsSummary({
  customer,
  coupons = [],
  campaign,
}) {
  return (
    <div className="flex w-full flex-col divide-y-4 divide-dotted bg-white p-10 text-xs text-black">
      {/* header */}
      <div className="flex justify-between pb-3">
        <span className="text-sm">{campaign.name}</span>
        <img className="w-8" alt="Logo Mar Shopping" src={MarShopping} />
      </div>
      {/* customer info */}
      <div className="flex flex-col py-3">
        <div className="flex gap-2">
          <span className="font-semibold">Nome:</span>
          <span>{`${customer?.firstName} ${customer?.lastName}`}</span>
        </div>
        <div className="mt-2 flex gap-2">
          <span className="font-semibold">Telemóvel:</span>
          <span>{customer?.phone}</span>
        </div>
        <div className="flex gap-2">
          <span className="font-semibold">Nº Identificação:</span>
          <span>{customer?.cc}</span>
        </div>
      </div>
      {/* coupons */}
      <div className="flex flex-col py-3">
        <span className="font-semibold">
          Total de Cupões: {coupons?.length}
        </span>
        <div className="mt-2 flex flex-col">
          {coupons.map((coupon, i) => {
            return <span key={i}>{coupon?.ROWID}</span>;
          })}
        </div>
      </div>
      {/* footer */}
      <div className="flex flex-col py-3">
        {format(new Date(), 'yyyy-MM-dd HH:mm')}
      </div>
      <div className="pt-3">{campaign.legalPhrase}</div>
    </div>
  );
}
